
import { KanziEnvironmentModel } from '@kanzi-apes/kanzi-models';

export const environment: KanziEnvironmentModel & {
  cognitoConfig: {
    cognitoUserPoolId: string;
    cognitoAppClientId: string;
    cognitoRegion: string;
    cognitoIdentityPoolId: string;
  };
  apiRestModules: {
    kongWMSAPI: {
      userConfigs: { apiURL: string; apiPath: string };
    };
  };
  qsApiKey: string;
  qsApiUrlAdmin: string;
  environment: string;
} = {
  production: false,
  environment: 'staging',
  kongApi: '',
  kongTrackingFile: '',
  qsApiUrlCommon: '',
  qsApiUrlAdmin: 'https://api-kongapiqs-staging.technoapes.io/',
  qsApiKey: '2lefohghzl9m9v8rQ9A4167wn2M1BHobqA8uoFU7',
  gmtZone: 'GMT-5',
  cognitoConfig: {
    cognitoUserPoolId: 'us-east-1_4D4DMCNFg',
    cognitoAppClientId: '47tie7v0m2g6e87al0fqpdfkav',
    cognitoRegion: 'us-east-1',
    cognitoIdentityPoolId: '',
  },
  apiRestModules: {
    kongWMSAPI: {
      userConfigs: {
        apiURL: '',
        apiPath: 'user-config',
      },
    },
  },
  formats: {
    date: 'MM/DD/YYYY',
  },
  assets: {
    logo: 'apes_logo.png',
    background: 'kanzi_assets_bg.jpg',
    root: 'assets/',
    rootClient: 'assets-clients/apes/',
    paths: {
      css: 'css/',
      logos: 'images/logos/',
      backgrounds: 'images/backgrounds/',
      js: 'js/',
    },
  },
  apiModules: {
    auth: 'auth/',
    authToken: 'token/login/',
    config: 'core_config/',
  },
  modules: {
    customerType: 'STOCK_MANAGEMENT',
    dashboards: true,
  },
};
